<script>
  export default {
    name: 'input-rd',
    props: ['label', 'type', 'disabled', 'name', 'error', 'placeholder', 'type', 'required', 'value', 'type'],
    computed: {
      inputVal: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val);
        }
      },
      eyeIcon() {
        return this.inputType === 'text' ? 'eye-hide' : 'eye'
      }
    },
    data() {
      return {
        inputType: this.type || 'text'
      }
    },
    methods: {
      togglePassword() {
        if (this.inputType === 'password') {
          this.inputType = 'text'
        } else {
          this.inputType = 'password'
        }
      },
      focus() {
        this.$refs.input.focus();
      }
    }
  }
</script>

<template>
  <div class="input-wrapper">
    <label :for="name" v-if="label" class="label-input text-14 fw-500">{{label}}<span v-if="required" class="text-error text-14 fw-500">*</span></label>
    <div class="input-rd input-rd--state" :class="{ 'input__disabled': disabled, 'input__error': error }">
      <input ref="input" :disabled="disabled" :type="inputType" class="text-16 fw-300 input-rd--item" :placeholder="placeholder || 'Type here...' | translate" v-bind="$attrs" :id="name" :name="name" v-model="inputVal" />
      <button @click="togglePassword" type="button" class="action-btn">
        <icon-rd :name="eyeIcon" v-if="type === 'password'" color="disabled" />
      </button>
    </div>
    <span class="text-error text-14 fw-300" v-if="error">{{error | translate}}</span>
  </div>
</template>

<style lang="less" scoped>
  @import "../../less/redesign/base.less";

  .input-rd--state {
    display: flex;
    &:focus-within {
      border: 1px solid @primary-blue;
    }
    &:hover {
      border: 1px solid @secondary-active;
      box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.11);
    }
  }

  input.input-rd--item {
    &::placeholder {
      color: @grey-input;
    }
    outline: none;
    background: none;
    border: none;
    flex: 1;
    max-width: 100%;
    padding: 0;
    height: unset;
  }

  .action-btn {
    background: none;
    border: none;
    outline: none;
  }

</style>



// WEBPACK FOOTER //
// src/ui/input/Input.vue